export const CHARACTER_EVENTS = {
  // the character is out of arena
  OUT_OF_RING: 'out_of_ring',
  BEGIN_CONTACT: 'on_begin_contact',
  END_CONTACT: 'on_end_contact',
  OVERCHARGE: 'on_overcharge',
  DISCHARGE: 'on_discharge',
  GETS_FREEZER: 'on_get_freezer_hit',
  UNFREEZE: 'on_unfreeze',
  GETS_COIL: 'on_get_coil_hit',
  PICK_CRYSTAL_FREEZER: 'on_pick_crystal_freezer',
  PICK_CRYSTAL_HULK: 'on_pick_crystal_hulk',
  PICK_CRYSTAL_COIL: 'on_pick_crystal_coil',
  EXTERNAL_SPIN_CHANGE: 'on_external_force_change_spin',
  TELEPORT: 'on_teleport_use',
  IMPULSE_ON: 'on_impulse_itself',
  IMPULSE_OFF: 'on_stop_impulse_itself'
}

export const GAME_EVENTS = {
  READY_ON: 'gameplay_ready_on',
  READY_OFF: 'gameplay_ready_off',
  SYSTEM_ONLINE: 'gameplay_system_is_online',
}